module.exports = __webpack_public_path__ + "static/media/lifeline_step_6_neg.4ccca132.png";